export enum LivingTenantOption {
    UNKNOWN = 0,
    CHILDREN_ALLOWED = 1,
    PETS_ALLOWED = 2,
  }
